var accordions = document.querySelectorAll('.accordion > .cursor');
accordions.forEach(function (single_accordion) {
  single_accordion.addEventListener('click', function (e) {
    e.preventDefault();
    if (this.parentNode.classList.contains('open')) {
      this.parentNode.classList.remove('open');
    } else {
      remove_class();
      this.parentNode.classList.toggle('open');
    }
  });
});

function remove_class() {
  var accordions_blocks = document.querySelectorAll('.accordion');
  accordions_blocks.forEach(function (single_block) {
    single_block.classList.remove('open');
  });
}

document.addEventListener('DOMContentLoaded', (event) => {
  if (window.location.hash) {
    const accordionId = window.location.hash.replace("#", "")
    const accordion = document.getElementById(accordionId)
    accordion.classList.add("open")
    window.scrollTo({
      top: accordion.offsetTop,
      left: 0,
      behavior: 'auto'
    })
  };
})